import { render, staticRenderFns } from "./StaffCustomerProfileEdit.vue?vue&type=template&id=9bc032cc"
import script from "./StaffCustomerProfileEdit.vue?vue&type=script&lang=js"
export * from "./StaffCustomerProfileEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports